import React, { useState } from 'react';
import CheckBox from "../CheckBox";
import IconButton from "../IconButton";
import './index.scss';
import classNames from 'classnames';

const CustomTableColumnVisibleFilter = ({ columns, columnVisible, setColumnVisible, maxHeight, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filteredColumns = columns.filter(col =>
    col.title.toLowerCase().includes(search.toLowerCase()) && !col.alwaysHidden
  );

  const handleOnClickX = () => {
    if(search) {
      setSearch("");
      return;
    }

    setIsOpen(false);
  }

  const isAllOn = () => {
    if (filteredColumns.length === 0) return false;
    return filteredColumns.every(col => columnVisible.includes(col.key));
  };

  const toggleAll = () => {
    if (isAllOn()) {
      setColumnVisible(columnVisible.filter(k => !filteredColumns.some(fc => fc.key === k)));
    } else {
      const keysToAdd = filteredColumns.map(fc => fc.key);
      setColumnVisible([...new Set([...columnVisible, ...keysToAdd])]);
    }
  };

  const isVisible = key => columnVisible.includes(key);

  const toggleVisible = (key) => {
    if (isVisible(key)) {
      setColumnVisible(columnVisible.filter(k => k !== key));
    } else {
      setColumnVisible(columnVisible.concat(key));
    }
  };

  return (
    <div className="customTableColumnVisibleFilter">
      <div className="columnsButton" onClick={() => setIsOpen(!isOpen)}>
        <IconButton isIcon iconName="columns" />
        <span>{t("orders.COLUMNS_BUTTON")}</span>
      </div>

      {isOpen && (
        <div className="visibleColumnSettings" style={{ maxHeight }}>
          <div className="ant-column-filter-dropdown">
            <input
              placeholder={t("orders.SERACH_COLLUMN_TYPE")}
              type="text"
              className={classNames("searchInput")}
              value={search}
              onChange={({ target }) => setSearch(target.value)}
            />
            <IconButton isIcon iconName={'crossCloseRounded'} onClick={handleOnClickX}/>
          </div>

          <div onClick={toggleAll} className="toggleAllControl">
            <CheckBox
              onChange={toggleAll}
              value={isAllOn()}
              label={isAllOn() ? t("orders.DESELECT_ALL_FILTER") : t("orders.SELECT_ALL_FILTER")}
            />
          </div>

          {filteredColumns.map(column => (
            <div key={column.key} onClick={() => toggleVisible(column.key)}>
              <CheckBox
                onChange={() => toggleVisible(column.key)}
                value={isVisible(column.key)}
                label={column.title}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomTableColumnVisibleFilter;
